import { render, staticRenderFns } from "./ChatInput.vue?vue&type=template&id=406de368&scoped=true&lang=pug&"
import script from "./ChatInput.vue?vue&type=script&lang=js&"
export * from "./ChatInput.vue?vue&type=script&lang=js&"
import style0 from "./ChatInput.vue?vue&type=style&index=0&id=406de368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406de368",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/Kou/projects/vue-projects/joseph/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
